"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupPlugin = void 0;
const BasePlugin_1 = require("./BasePlugin");
class GroupPlugin extends BasePlugin_1.BasePlugin {
    execute(list, _activities, _groups, _conditions, _selected) {
        const selectedGroupMap = new Map();
        for (const activity of list) {
            const groupId = activity.activity_group_id;
            if (!groupId) {
                continue;
            }
            if (activity.registered) {
                if (!selectedGroupMap.has(groupId)) {
                    selectedGroupMap.set(groupId, {
                        selectedId: activity.id,
                        disableAll: false,
                    });
                }
                else if (selectedGroupMap.has(groupId)) {
                    // this means that there are
                    // more than one activites have been selected
                    // for this group (fraudulent behaviour)
                    // so we should disabled all of them
                    selectedGroupMap.set(groupId, {
                        selectedId: activity.id,
                        disableAll: true,
                    });
                }
            }
        }
        for (const activity of list) {
            const groupId = activity.activity_group_id;
            if (!groupId) {
                continue;
            }
            // we disable if it's still open for select
            // OR if group has more than one selected activities
            if (selectedGroupMap.has(groupId) &&
                (this._isOpenForSelect(activity) ||
                    selectedGroupMap.get(groupId)?.disableAll)) {
                activity.disabled = true;
                activity.disabledbyid =
                    selectedGroupMap.get(groupId)?.selectedId;
            }
        }
        return list;
    }
}
exports.GroupPlugin = GroupPlugin;
